var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"tab-item",attrs:{"role":"tabpanel","id":this.id,"aria-labelledby":this.parentId,"aria-expanded":this.isActive,"hidden":!this.isActive,"tabIndex":"0"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }